export default {"src":"/_next/static/media/maintenance.9f8d9186.svg","height":507,"width":512,"blurWidth":0,"blurHeight":0};